module.exports = __webpack_public_path__ + "img/s1.6dce9817.jpg";